import { render, staticRenderFns } from "./InlayView.vue?vue&type=template&id=cfc37016&scoped=true"
import script from "./InlayView.vue?vue&type=script&lang=js"
export * from "./InlayView.vue?vue&type=script&lang=js"
import style0 from "./InlayView.vue?vue&type=style&index=0&id=cfc37016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc37016",
  null
  
)

export default component.exports